import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=978cd092&vue3"
import script from "./toolbar.vue?vue&type=script&lang=js&vue3"
export * from "./toolbar.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports